import { deviceSystemAgeOptions } from "constants/DeviceSystemAgeOptions"
import {
  deviceAccessoriesOptions,
  deviceSystemTypeOptions,
  hvacOptions,
  optInOptions,
} from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { CustomerMembershipType } from "components/table/columnComponents/CustomerMembershipType"
import MessageCenterSeeMessage from "components/table/columnComponents/MessageCenterSeeMessage/MessageCenterSeeMessage"
import { OptedInOut } from "components/table/columnComponents/OptedInOut"
import RowExpandToggle from "components/table/columnComponents/RowExpandToggle"

export const messageCenterHeaderCells: UITypes.TableHeaderCell[] = [
  { title: "", size: "mini", name: "group_toggle", cellComponent: RowExpandToggle },
  {
    title: "",
    name: "checkbox",
    type: "checkbox",
    size: "mini",
    cellComponent: "checkbox",
  },
  {
    title: "Email",
    type: "sort-search",
    name: "email",
    size: "middle",
  },
  {
    title: "Device S/N",
    type: "sort-search",
    name: "sn",
    size: "small",
  },
  {
    title: "Schedule",
    type: "default",
    name: "schedule",
    size: "small",
    cellComponent: "datetime",
  },
  {
    title: "Scheduled Message",
    type: "default",
    name: "scheduled_message",
    size: "middle",
    cellComponent: MessageCenterSeeMessage,
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
    size: "small",
  },
  {
    title: "City",
    type: "sort-search",
    name: "city",
    size: "small",
  },
  {
    title: "Zip code",
    type: "sort-search",
    name: "zip_code",
    size: "small",
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
    size: "small",
  },
  {
    title: "Opt in/out",
    type: "select",
    name: "option",
    size: "small",
    options: optInOptions,
    cellComponent: OptedInOut,
  },
  {
    title: "Activation date",
    type: "sort-date-range",
    name: "activation_date",
    size: "middle",
  },
  {
    title: "Customer name",
    type: "sort-search",
    name: "homeowner_name",
  },
  {
    title: "Membership",
    type: "sort-search",
    name: "membership",
    size: "small",
  },
  {
    title: "Membership type",
    type: "search",
    name: "membership_name",
    size: "middle",
    cellComponent: CustomerMembershipType,
  },
  {
    title: "Residence type",
    type: "sort-search",
    name: "residence_type",
    size: "middle",
  },
  {
    title: "System type",
    type: "select",
    size: "small",
    name: "system_type",
    options: deviceSystemTypeOptions,
  },
  {
    title: "System age",
    type: "select",
    size: "middle",
    name: "system_age",
    options: deviceSystemAgeOptions,
  },
  {
    title: "Accessories",
    type: "select",
    name: "accessories",
    options: deviceAccessoriesOptions,
    size: "small",
  },
  {
    title: "Installation type",
    type: "select",
    size: "small",
    name: "installation_type",
    options: hvacOptions,
  },
]
